import React from 'react'
import * as d3 from "d3";
import d3Tip from "d3-tip";
import utils from './app-util';

const TEXT_ANCHOR = "text-anchor";

function createColorScale(groups) {
    const colorRange = [], groupLength = groups.length;
    const valConst = 1 / groupLength;
    let incrementedVal = 0, i = 0;
    while (i < groupLength) {
        incrementedVal = incrementedVal + valConst;
        colorRange.push(d3.interpolateReds(incrementedVal))
        i++;
    }
    const  reverseColorRange= [...colorRange].reverse();
    const colorScale = d3.scaleOrdinal().domain(groups).range(reverseColorRange);
    return colorScale;
}
function stackMax(stacks) {
    return d3.max(stacks, function (d) {
        return d[1];
    });
}
function stackMin(stacks) {
    return d3.min(stacks, function (d) {
        return d[0];
    });
}
export function createLegend(_thisContext, legendGroupsList, colorScale, legendContainerNode) {
    const all = d3.select(legendContainerNode).selectAll(".legendDiv")
    if(all.size() > 0){
        all.each(function(){
            d3.select(this).remove()
        })
    }
    const legends =d3.select(legendContainerNode).selectAll("div").data(legendGroupsList)
    .enter()
    .append("div").attr('class', "legendDiv mr-4").style("display", "inline-block")
    legends.append("span").attr('class', 'mr-1').style("display", "inline-block").style("width", "30px").style("height", "7px").style("background-color",colorScale)
    legends.append("span").style('font-size','10px').text(function (d) {
        return d;
    });
}

class StackedBarchart extends React.Component {
    constructor(props) {
        super(props);
        this.createBarChart = this.createBarChart.bind(this);
        this.node = React.createRef();
        this.msgElem = React.createRef();
        this.legendContainer = React.createRef();
    }

    componentDidMount() {
        this.margin = { top: 40, right: 10, bottom: 40, left: 40 };
        this.svg = d3.select(this.node.current);
        this.width = utils.getFixedPlotDimension().width - this.margin.left - this.margin.right - 20;
        this.height = utils.getFixedPlotDimension().height - this.margin.left - this.margin.right;
        this.xScale = d3.scaleBand().range([0, this.width]).padding(0.1);
        this.yScale = d3.scaleLinear().range([this.height, 0]);
        this.xAxis = d3.axisBottom(this.xScale);
        this.yAxis = d3.axisLeft(this.yScale);
        
        this.center = d3.scaleLinear().range([0, this.width]);
        this.centerLine = d3.axisTop(this.center).ticks(0);
        this.svg.append("g")
                .attr("class", "centerline")
                .attr("transform", `translate(${this.margin.left}, ${this.yScale(0) + this.margin.top} )`)
        d3.select(this.node.current).select(function () {
            this.parentNode.style.overflow = "auto";
        })
        this.svg
            .attr("width", this.width + this.margin.left + this.margin.right)
            .attr("height", this.height + this.margin.top + this.margin.bottom);
        this.svg.append("g").attr("class", "x axis ")
            .attr('id', "xAxis")
            .attr("transform", `translate(${this.margin.left}, ${this.height + this.margin.top})`);
        this.svg.append("g")
            .attr("class", "y axis")
            .attr('id', "yAxis")
            .attr("transform", `translate(${this.margin.left}, ${this.margin.top})`);

        this.svg.append("text")
            .attr('class', "xlabel")
            .attr(TEXT_ANCHOR, "end")
            .attr("x", this.width / 2 + 100)
            .attr("y", this.height + this.margin.bottom + this.margin.top - 5)
            .text(this.props.data.x_label)
            .style("font-size", "12px");
        this.svg.append("text")
            .attr('class', "ylabel")
            .attr("x", -200)
            .attr("y", 15)
            .attr("transform", "rotate(-90)")
            .style("font-size", "12px")
            .attr(TEXT_ANCHOR, "start")
            .text(this.props.data.y_label);

        this.tip = d3Tip()
            .attr("class", "d3-tooltip")
            .offset([-10, 0])
            .html(function (_d) {
                const nodeData = d3.select(this).data()[0];
                const key = d3.select(this).attr("data-key");
                return `${key}: ${nodeData.data[key]}`;
            });
        this.svg.call(this.tip)
        
        this.createBarChart();

        const __this = this
        const defaultWidth = parseFloat(__this.svg.attr('width') - 50);
        const defaultHeight = parseFloat(__this.svg.attr('height'));
        function updateOnFS() {
            document.querySelector(".tab-pane.active.show.graph .f-screen").style.width = __this.width;
            document.querySelector(".tab-pane.active.show.graph .f-screen").style.height = __this.height;
            __this.svg.attr("width", __this.width + __this.margin.left + __this.margin.right)
                .attr("height", __this.height + __this.margin.top + __this.margin.bottom);
            __this.xScale.range([0, __this.width]).padding(0.1)
            __this.yScale.range([__this.height, 0])
            __this.svg.select('.x.axis').attr("transform", "translate(" + __this.margin.left + "," + (__this.height + __this.margin.top) + ")");
            __this.svg
                .transition()
                .attr("width", __this.width + __this.margin.left + __this.margin.right)
                .attr("height", __this.height + __this.margin.top + __this.margin.bottom)

            __this.svg.select(".xlabel")
                .attr("x", __this.width / 2 + 100)
                .attr("y", __this.height + __this.margin.bottom + __this.margin.top - 5);
        }
        [...document.querySelectorAll(".graph-analysis .tab-pane.graph")].forEach(function (element) {
            element.addEventListener('fullscreenchange', (_e) => {
                if (document.fullscreenElement) {
                    __this.width = window.innerWidth - 100;
                    __this.height = window.innerHeight - 200;
                    updateOnFS()
                } else {
                    __this.width = defaultWidth;
                    __this.height = defaultHeight;
                    updateOnFS()
                }
                setTimeout(() => {
                    __this.createBarChart();
                }, 100);
            })
        })
        this.svg.attr("class", this.props.type);
        if (this.props.type === 'cost') {
            document.querySelector(".graph-analysis .tab-wrapper .nav-item a[aria-controls='cost']").addEventListener("click", graphTabContainerOnChange);
        } else if (this.props.type === 'schedule') {
            document.querySelector(".graph-analysis .tab-wrapper .nav-item a[aria-controls='schedule']").addEventListener("click", graphTabContainerOnChange);
        } else if (this.props.type === 'probability') {
            document.querySelector(".graph-analysis .tab-wrapper .nav-item a[aria-controls='probability']").addEventListener("click", graphTabContainerOnChange);
        }

        function graphTabContainerOnChange(_e) {
            const svgElement = document.querySelector('.graph-analysis .tab-wrapper .tab-content svg.clickactive');
            const heatMapFilterActiveElement = document.querySelector('.graph-analysis .tab-wrapper .tab-content #heatmap rect.clicked')
            const isHeatMapFilterActive = (heatMapFilterActiveElement !== null);
            if (svgElement !== null) {
                svgElement.classList.remove('clickactive');
                __this.props.stackedBarChartFIlterCallback({ id: "", filter: false });
            }else if(isHeatMapFilterActive){
                heatMapFilterActiveElement.classList.remove('clicked');
                __this.props.stackedBarChartFIlterCallback({ id: "", filter: false });
            }
        }
    }

    shouldComponentUpdate(prevProps, _prevState, _snapshot) {
        if (this.props.dataType === 'quality') {
            const qualityTab = JSON.parse(sessionStorage.getItem("qualityTab"));
            if ((prevProps.data.isNew || (prevProps.data.isNew === undefined)) && !qualityTab.otclicked && !qualityTab.stclicked && qualityTab.newload) {
                this.createBarChart();
            }
            return false;
        }
        else if(prevProps.data.isNew || (prevProps.data.isNew === undefined)) {
            this.createBarChart();
            return true;
        }
        return false;
    }

    checkValue(values, keys) {
        let allZero = true;
        for (let i = 0; i < values.length; ++i) {
            for (let j = 0; j < keys.length; ++j) {
                if (values[i][keys[j]] > 0) {
                    allZero = false;
                    break;
                }
            }
        }
        return allZero;
    }
    checkIfAllValueZero(values, _newData, keys) {
        let allZero = true;
        if ((values !== undefined) && (_newData !== undefined)) {
            allZero = this.checkValue(values, keys)
        }
        return allZero;
    }
    rectBarOnClick(_selfContext) {
        let filter = false;
        if (d3.select(_selfContext).classed("active") && this.svg.classed('clickactive')) {
            d3.select(_selfContext).classed("active", false);
            this.svg.classed('clickactive', false);

        } else {
            d3.select(_selfContext).classed("active", true);
            this.svg.classed('clickactive', true);
            filter = true;
        }
        // clear the highlighted rect on other rect clicking
        
        if ((this.isRectHighlighted !== null) && !this.isRectHighlighted.isSameNode(_selfContext)) {
            this.isRectHighlighted.classList.remove('active');
        }
        
        this.isRectHighlighted = _selfContext;

        const idsOrCategory = d3.select(_selfContext).attr("data-ids");
        this.props.stackedBarChartFIlterCallback({ id: idsOrCategory, filter: filter });
    }
    createBarChart() {
        const __this = this;
        const data = this.props.data.data;
        if (!this.checkIfAllValueZero(data, this.props.data.isNew, this.props.data.groups)) {
            __this.svg.style('display', 'block')
            __this.msgElem.current.classList.remove('active');
            __this.legendContainer.current.classList.remove('d-none');
            this.props.data.isNew = false;
            const groups = this.props.data.groups;
            __this.color = createColorScale(groups);
            if(__this.legends === undefined){
                createLegend(this, groups, __this.color, this.legendContainer.current);
            }
            const stack = d3.stack().keys(groups).order(d3.stackOrderNone).offset(d3.stackOffsetDiverging);

            __this.xScale.domain(data.map(function (d) {
                return d.label;
            }));
            __this.yScale.domain([d3.min(stack(data), stackMin), d3.max(stack(data), stackMax)]);

            //------------------------------------------------------------------------------------------------------
            const x_var = "label";
            this.isRectHighlighted = null;
            __this.svg.selectAll(".bar").remove();
            groups.forEach(function (key, key_index) {
                const bar = __this.svg.selectAll(".bar-" + key.replace(/\s|,|:|\(|\)|\//g, '_'))
                    .data(stack(data)[key_index], function (d) {
                        return d.data[x_var] + "-" + key;
                    });

                bar.transition()
                    .attr("x", function (d) { return __this.xScale(d.data[x_var]); })
                    .attr("y", function (d) { return __this.yScale(d[1]); })
                    .attr("height", function (d) { return __this.yScale(d[0]) - __this.yScale(d[1]); });
                bar.enter().append("rect")
                    .attr("class", function (_d) { return "bar bar-" + key.replace(/\s|,|:|\(|\)|\//g, '_'); })
                    .attr("data", function (d) {

                        return d.data[key];
                    })
                    .attr("data-key", key)
                    .attr("data-ids", function (d, i) {
                        return d.data[`${__this.props.dataType}_ids`][key][i];
                    })
                    .attr("x", function (d) { return __this.xScale(d.data[x_var]); })
                    .attr("y", function (d) { 
                        return __this.yScale(d[1]); 
                    })
                    .attr("height", function (d) { return __this.yScale(d[0]) - __this.yScale(d[1]); })
                    .attr("width", __this.xScale.bandwidth())
                    .attr("fill", function (_d) { return __this.color(key); }).attr("transform", "translate(" + __this.margin.left + "," + __this.margin.top + ")")
                    .attr("width", __this.xScale.bandwidth())
                    .on("mouseover", __this.tip.show)
                    .on("mouseout", __this.tip.hide)
                    .on("click", function (_d) {
                        __this.rectBarOnClick(this);
                    }).style("cursor", "pointer");
            });
            __this.svg.select('.centerline')
            .attr("transform", `translate(${__this.margin.left}, ${__this.yScale(0) + __this.margin.top} )`)
            __this.svg.select('.centerline').call(__this.centerLine);
            __this.svg.select('.x.axis').call(__this.xAxis);
            __this.svg.select('.y.axis').call(__this.yAxis);
        } else {
            __this.svg.style('display', 'none')
            __this.msgElem.current.classList.add('active');
            __this.legendContainer.current.classList.add('d-none');
        }
    }

    render() {
        return (
            <>
                <div className='no-data-msg-placeholder font-italic my-4 small text-center' ref={this.msgElem}>No data found</div>
                <div className='legendContainerStackedBarchart' ref={this.legendContainer} style={{textAlign: 'justify'}}></div>
                <svg id={`${this.props.type}Plot`} ref={this.node} width="100%" height="300"></svg>
            </>
        );
    }
}
export default StackedBarchart
